import { render } from "./HackathonSubmissionPeriod.vue?vue&type=template&id=423b2c47"
import script from "./HackathonSubmissionPeriod.vue?vue&type=script&lang=js"
export * from "./HackathonSubmissionPeriod.vue?vue&type=script&lang=js"
script.render = render

export default script